module.exports = __webpack_public_path__ + "images/emoji/satellite.47ed9f0d35c09e221370.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/satellite.png
// module id = YPtf
// module chunks = 2